const PAGE_KEYS = {
  home: "Home",
  dashboard: "Dashboard",

  items: "Items",
  itemDetails: "ItemDetails",
  category: "category",
  unit: "unit",

  services: "Services",
  servicesCategory: "ServicesCategory",

  party: "Party",
  partyDetails: "PartyDetails",
  editParty: "EditParty",

  purchase: "Purchase",
  createPurchase: "CreatePurchase",
  purchase_order_list: "purchase-order-list",

  //sale
  sale: "Sale",
  sale_order: "Sale Order",
  createSale: "Create-Sale",

  pricing: "Pricing",
  features: "Features",
  featuressection: "FeaturesSection",
  industry: "Industry",
  industrydata: "IndustryData",
  partner: "Partner",

  business: "Business",
  addBusiness: "AddBusiness",

  returns: "ReturnPage",

  expenses: "Expenses",
  expensesCategory: "ExpensesCategory",

  transaction: "Transaction",
  transactionDetail: "TransactionDetail",

  reports: "Reports",

  employee: "Employee",
  editEmployee: "EditEmployee",
  shift: "Shift",
  attendance: "Attendance",

  zoomControls: "ZoomControls",

  account: "Account",
  prefix: "Prefix",
  createBusiness: "CreateBusiness",
  location: "Location",
  saleOrderList: "SaleOrderList",
};

export default PAGE_KEYS;
